export const FANVUE_PROFILE_URL =
  'https://www.fanvue.com/realalexa_narvaez/fv-5'

export function isFanvueProfileUrl(url: string): boolean {
  return url.includes('fanvue.com')
}
